<template>
  <VueModal modal-class="modal modal-lg"  title="Edit Profile: Our Story" v-model="modalOpen">
    <div>
      <div class="mb-12">
        <label for="story" ref="story">
          What’s your organization’s story?
          <span class="text-sm font-sans-book block">
            900 characters maximum. This is your bio and description, which can include your mission statement, types of resources you provide, and/or what inspired you to do this work. Use I/we when you can; stories are better when they are in your personal voice!
          </span>
        </label>

        <textarea
          id="story"
          name="story"
          v-model="form.story"
          v-validate="'max:900'"
          class="w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent"
        />

        <div class="text-sm font-sans-italic text-gray-dark mt-1">
          Character count: {{ form.story ? form.story.length : 0 }}
        </div>

        <span v-show="errors.has('story')" class="error text-error-red text-lg">
        {{ errors.first('story') }}
      </span>
      </div>
      <div class="flex justify-center">
        <button type="button" class="button" @click="update">
          Update
        </button>
      </div>
    </div>
  </VueModal>
</template>

<script>
import VueModal from '@kouts/vue-modal'
import {mapGetters} from "vuex";
import {organizationAPI} from "../../../../../api/organizationAPI";

export default {
  name: "OrganizationStoryModal",
  props: {
    value: { type: Boolean, required: true }
  },
  components: { VueModal },
  computed: {
    ...mapGetters({ organization: "organization" }),
    modalOpen: {
      get() {
        return this.value;
      },
      set(localModalIsSet) {
        this.$emit('input', localModalIsSet);
      }
    }
  },
  watch: {
    organization() {
      this.setForm();
    }
  },
  data() {
    return {
      form: {
        story: ''
      },
      loading: false,
    }
  },
  methods: {
    setForm() {
      this.form.story = this.organization.story;
    },
    async update() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      await organizationAPI.updateProfileStory(this.form);
      await this.$store.dispatch('getMe');
      await this.$store.dispatch('getOrganization', { id: this.organization.id });
      this.loading = false;
      this.modalOpen = false;
    }
  },
  mounted() {
    this.setForm();
  }
}
</script>

<style scoped>

</style>